<script setup lang="ts">
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk}: Scripted Pixels: Design , Develop, Deliver` : 'Scripted Pixels: Design, Develop, Deliver.'
  },
  meta: [
    { charset: "utf-8" },
    { name: "HandheldFriendly", content: "True" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },

    {
      name: "description",
      content: "Scripted Pixels: Design, Develop, Deliver.",
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      property: "og:description",
      content: "Scripted Pixels: Design, Develop, Deliver.",
    },
    {
      property: "og:image",
      content: "/avatar.png",
    },
  ],
});

import Navigation from "@/components/TheNavbar.vue";
import Footer from "@/components/TheFooter.vue";
</script>

<template>
  <Navigation />
  <NuxtLoadingIndicator
    :color="'repeating-linear-gradient(to right, #ff0000, #3da8f5, #53fa00, #b300ff, #ff5500, #ff0091)'"
  />
  <NuxtPage />
  <Footer />

  <TheContactModal />
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
